<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
      <div class="dynamicList-loading"
           v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>

      <div class="md-layout-item md-size-100">
        <InputSearchModal v-model="targetAccount" :config="accountSearchModalConfig" />
      </div>
      <div>
        <md-table v-model="serviceList" @md-selected="onSelect" class="table-striped __custom-table" ref="tableRef">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="multiple"
            md-auto-select
          >
            <md-table-cell md-label="Service">{{ item.name }}</md-table-cell>
            <md-table-cell md-label="Merchant Number">{{ item.merchantNumber }}</md-table-cell>
            <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
            <md-table-cell md-label="Created At">{{ item.createdAt }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
        
      <div class="md-card-actions md-alignment-space-between">
        <div>
          <md-button class="md-button btn-next md-success md-theme-default" @click="runMergeAccount()" :disabled="isDisabled">Ok</md-button>
          <md-button class="md-theme-default" @click="atClose">Close</md-button>
        </div>
      </div>
      <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="alertDialog.show"
      :md-title="alertDialog.title"
      :md-content="alertDialog.message" />
      <md-dialog-confirm
        :md-active.sync="confirmDialog.show"
        :md-title="confirmDialog.title"
        :md-content="confirmDialog.content"
        :md-confirm-text="confirmDialog.confirm"
        :md-cancel-text="confirmDialog.cancel"
        @md-cancel="cancelConfirmDialog"
        @md-confirm="confirmConfirmDialog"
      />
  </component>
</template>

<script>
import _ from "lodash";
import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';
import * as mutations from '@/graphql/mutations';
import * as subscriptions from '@/graphql/subscriptions';
import gql from "graphql-tag";
import InputSearchModal from "@/components/Inputs/InputSearchModal";
export default {
  components: {
    InputSearchModal
  },
  props: {
    list: {
      type: Object,
      required: false
    },
    atClose: {
      type: Function
    },
    serviceList: {
      type: Array
    }
  },
  data() {
    return {
      confirmDialog: {
        show: false,
        title: "",
        content: "",
        confirm: "Yes",
        cancel: 'Cancel'
      },
      alertDialog: {
        show: false,
        title: "",
        message: "",
      },
      difference: false,
      incrementalProductServiceList: [],
      allProductServiceList: [],
      isPromisePending: false,
      selectedAccount: null,
      isDisabled: true,
      targetAccount: [],
      selectedServices: [],
      selectedServicesProducts: [],
      accountSearchModalConfig: {
        limit: 1,
        label: "Account",
        pageMode: "edit",
        name: "account",
        subscribe: {
        },
        list: {
          hideNewRecordButton: true,
          hideListHeader: true,
          editPath: "accounts",
          objectName: "account",
          pageTitle: "accounts",
          pageIcon: "store",
          listQueryId: "searchAccounts",
          responseFieldName: "searchAccounts",
          createMutationId: "createAccount",
          deleteQueryId: "deleteAccount",
          isPortfolioAddLogDisabled: true,
          deleteQueryIdField: "id",
          deleteMessageTitle: "Are you sure you want to remove {objectName}?",
          deleteMessageText: "",
          linkRows: false,
          skipCardLayout: true,
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddReportPortfolio",
            },
          ],
          columns: {
            company: { label: "Company", sortable: false, searchable: true, display: true, nested: "name"  },
            name: { label: "DBA Name", sortable: true },
            nameLegal: { label: "Legal Name", sortable: true },
            addressPhysical: { label: "Address", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
          },
          fuseSearch: null,
          relateRecordInput: {
            name: null,
            description: null,
          },
          relateRecordInputField: null,
          relateRecordRouteField: "id",
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchAccounts && data.searchAccounts.items && data.searchAccounts.items.length) {
              let items = data.searchAccounts.items;
              items.forEach((item) => {
                /** Format addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });

                /**
                 * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                 * 
                 * Remove Country code and underscores from Address fields
                 */
                if(item.addressPhysical) {
                  item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                }
                if(item.addressMailing) {
                  item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                }

                result.push(item);
              })
            }
            return result;
          },
        },
      },
    };
  },
  apollo: {
    subscriptions: {
      query: function() {
        return gql(queries['searchUsers']);
      },
      variables: {
        filter: { id: { eq: '-1' } },
        limit: 1,
      },
      update: () => [],
    }
  },
  watch: {
    'targetAccount': {
      immediate: true,
      handler: function(){
        this.selectedAccount = this.targetAccount.length ? this.targetAccount[0] : null;
      }
    },
    'selectedAccount': {
      immediate: true,
      handler: function(){
        this.isDisabled = this.difference || !this.selectedAccount ? true : false;
      }
    },
  },
  computed: {},
  methods: {
    cancelConfirmDialog() {
      this.confirmDialog.title = '';
      this.confirmDialog.content = '';
    },
    confirmConfirmDialog() {
      for(let i=0; i < this.selectedServices.length; i++) {
        this.updateServiceData(this.selectedServices[i], this.selectedAccount);
      }
      for(let i=0; i < this.selectedServicesProducts.length; i++) {
        this.updateProductData(this.selectedServicesProducts[i], this.selectedAccount);
      }
      this.afterUpdateAction(this.selectedAccount);   
    },
    enablePageScroll() {
      const body = document.querySelector('body');
      body.classList.remove('isMergeDialogOpen');
    },
    async getProductList() {
      let selectedServiceIds = [];
      this.allProductServiceList = [];
      this.incrementalProductServiceList = [];
      let params = {
        limit:999,
        sort: {"direction":"desc","field":"createdAt"}   
      };
      let filter = {
      "bool":
        {
          "filter":
          {
            "bool":
            {
              "should":[],
              "minimum_should_match" : 1
            }
          }
        }
      }
      for(let i=0; i< this.selectedServices.length;i++) {
        filter.bool.filter.bool.should.push({"match_phrase":{"productServiceServiceId.keyword":  this.selectedServices[i].id}})
        selectedServiceIds.push(this.selectedServices[i].id);
      }        

      params.filter = {
        esQuery: JSON.stringify(filter)
      }

      let response = null;
      let error = null;
      let haveData = true;
      let page = 0;
      while (haveData) {
        error = null;
        response = await API.graphql(graphqlOperation(queries_custom["searchServiceProductByServiceCustoms"], params))
        .catch(err => {
            error = err
            if(err.data.searchProductServices){
              this.incrementalProductServiceList = this.incrementalProductServiceList.concat(err.data.searchProductServices.items);
            }
            haveData = err.data.searchProductServices && err.data.searchProductServices.items.length === params.limit ? true : false;
            if(haveData){
              page++
              params.nextToken = params.limit * page
            }
        });
        if (!error) {
          if(response.data.searchProductServices){
            this.incrementalProductServiceList = this.incrementalProductServiceList.concat(response.data.searchProductServices.items);
          }
          haveData = response.data.searchProductServices && response.data.searchProductServices.items.length === params.limit ? true : false;
          if(haveData){
            page++
            params.nextToken = params.limit * page
          }
        }
      }
      this.allProductServiceList = this.incrementalProductServiceList;
      this.checkServiceProductDependency(selectedServiceIds);
    },
    checkServiceProductDependency(selectedServiceIds) {
      this.difference = false;
      let dependentServiceIds = [];
      this.selectedServicesProducts = [];
      for(let i=0;i<this.allProductServiceList.length;i++) {
        this.selectedServicesProducts.push(this.allProductServiceList[i].product.id);
        let productServices = this.allProductServiceList[i].product.services.items;
        for(let i=0;i<productServices.length;i++) {
          if(productServices[i].service.account && productServices[i].service.account.id == this.$route.params.id )
            dependentServiceIds.push(productServices[i].service.id)
        }
      }
      let uniqueDependentServiceIds = _.uniq(dependentServiceIds);
      let difference =  _.difference(uniqueDependentServiceIds,selectedServiceIds);
      this.difference = difference.length ? true : false;
      if(this.difference)
      {
        this.alertDialog.show = true;
        this.alertDialog.title = "Selected service(s) cannot be moved";
        this.alertDialog.message = `Selected service(s) is tied to a product that is shared by a service not being moved`;
      }
      this.isDisabled = this.difference || !this.selectedAccount ? true : false;
    },
    async runMergeAccount(){
      const accountItem = this.selectedAccount;
      //build the name first
      let nameFields = this.list.mergeMessageNameFields ? this.list.mergeMessageNameFields : ['name'];
      let objectName = '';
      nameFields.forEach((nf, index) => {
        objectName += accountItem[nf];
        if (index !== nameFields.length -1) objectName += ' ';
      });

      let title = this.list.mergeMessageTitle;
      title = title.replace('{objectName}', objectName);
      title = title.replace('{sourceCase}', this.list.sourceCaseSubject);

      //this text is different because we want to allow config of '' to omit the default text
      let content = typeof this.list.mergeMessageText !== 'undefined' ? this.list.mergeMessageText : `The change cannot be undone.`;

      this.confirmDialog.show = true;
      this.confirmDialog.title = title;
      this.confirmDialog.content = content;
    },

    updateServiceData(service, account){
      let input = {};
      input['id'] = service.id;
      input['serviceAccountId'] = account.id;
      this.updateAction(this.list.updateServiceMutationId, input);
    },

    updateProductData(product, account){
      let input = {};
      input['id'] = product;
      input['productAccountId'] = account.id;
      this.updateAction(this.list.updateProductMutationId, input);
    },

    async updateAction(mutationId, updateInput) {
      await API.graphql(graphqlOperation(mutations[mutationId], {input: updateInput}))
      .then(result => {
        this.$c.log(mutationId + " result: ", result);
      })
      .catch(error => {
        this.$c.log(this.list.pageTitle + " updating record error:", error);
      });
    },

    afterUpdateAction(item) {
      this.alertDialog.show = true;
      this.alertDialog.title = "Service(s) moved";
      this.alertDialog.message = `You moved selected service(s) into "${item.name}" account.`;
      this.enablePageScroll();
      window.setTimeout(() => {
        this.atClose();
        this.$router.push("/" + this.list.editPath + "/" + item.id); 
      }, 4000);           
    },

    onSelect: function (items) {
      this.selectedServices = items;
      this.isDisabled = this.difference || !this.selectedAccount ? true : false;
      if(this.selectedServices.length)
        this.getProductList();
    },
  },
  mounted() {
    //select all services by default
    window.setTimeout(() => {
      const checkBoxElement = this.$refs.tableRef.MdTable.contentEl.querySelector(".md-table-head input[type='checkbox']");
      if(checkBoxElement)
        checkBoxElement.click();
    }, 1000);
  }
};
</script>

<style>
.md-dialog.__alertDialog.md-theme-default {
  width: 50% !important;
}

i.md-icon.md-icon-font.md-bottom-bar-icon.md-theme-default.__closeDialogIcon {
  cursor: pointer;
  width: 17px;
  float: right;
  padding-right: 8px;
  color: #fff;
}

span.md-dialog-title.md-title.__custom-dialog-title {
  background-color: #E4925C;
  color: #fff;
  font-weight: 500;
  text-align: center;
  padding: 10px 0px 10px;
}
.__custom-dialog-content.md-dialog-content.md-theme-default {
  padding: 0px;
}
.md-table.table-striped.__custom-table.md-theme-default table {
  width: 95%;
  margin: 10px 5px 0px 28px;
  border-spacing: 0;
  border-collapse: collapse;
  overflow: hidden;
  border: 1px solid #ddd !important;
}
.md-table.table-striped.__custom-table.md-theme-default th .md-table-head-label {
  color: #fff;
  font-weight: 400;
}
.md-table.table-striped.__custom-table.md-theme-default thead {
  background: #878787;
}
</style>

<style lang="scss" scoped>
.md-layout-item.md-size-100.__custom-layout-item {
  padding-right: 0px;
  padding-left: 0px;
}
h4.title.__custom-title {
  text-align: center;
  color: #000000 !important;
  margin: 3px 3px 14px 0px;
  font-weight: 500;
}
.md-content.md-table.table-striped.md-theme-default {
  margin-bottom: 2px;
  height: 320px;
}
</style>
